import React from 'react';
import Logo1 from 'Icons/RMlogo.png';

const LicenseHeader = () => (
  <div id="license-header-wrapper" className="flex-y-center my-5 py-2">
    <div>
      <img id="license-header-img-logo-1" src={Logo1} />
    </div>
    <div id="license-header-content" className="ml-2">
      <div id="license-header-content-1" className="license-header">
        ROCK MAKER
        <span id="lincense-header-content-registered-logo" className="registeredLogo">
          &#174;
        </span>
      </div>
      <div id="license-header-content-2" className="license-header2">
        Crystallization Software
      </div>
    </div>
  </div>
);
export default LicenseHeader;
